import { createClient, type SupabaseClient, type SupportedStorage } from '@supabase/supabase-js';

export type BsyncClient = SupabaseClient;

export interface ClientConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  /** Session storage. Extensions pass a chrome.storage-backed adapter. */
  storage?: SupportedStorage;
  /** Web pages detect the OAuth code in the URL; extensions exchange it manually. */
  detectSessionInUrl?: boolean;
}

export function createBsyncClient(cfg: ClientConfig): BsyncClient {
  if (!cfg.supabaseUrl || !cfg.supabaseAnonKey) {
    throw new Error('Missing Supabase configuration: set VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY (see .env.example).');
  }
  return createClient(cfg.supabaseUrl, cfg.supabaseAnonKey, {
    auth: {
      flowType: 'pkce',
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: cfg.detectSessionInUrl ?? false,
      storage: cfg.storage,
    },
    realtime: { params: { eventsPerSecond: 5 } },
  });
}
